module.exports = __webpack_public_path__ + "img/kop.5bcac9b5.png";